"use client";

export type AnalyticsConsentStatus = "unknown" | "decided";

interface AnalyticsConsentSnapshot {
	status: AnalyticsConsentStatus;
	analyticsGranted: boolean;
	preferencesGranted: boolean;
}

let snapshot: AnalyticsConsentSnapshot = {
	status: "unknown",
	analyticsGranted: false,
	preferencesGranted: false,
};

const listeners = new Set<() => void>();

export function subscribeAnalyticsConsent(listener: () => void): () => void {
	listeners.add(listener);
	return () => {
		listeners.delete(listener);
	};
}

function notifyAnalyticsConsentListeners(): void {
	for (const listener of listeners) {
		listener();
	}
}

export function setAnalyticsConsentSnapshot(
	status: AnalyticsConsentStatus,
	categories: {
		analyticsGranted: boolean;
		preferencesGranted: boolean;
	},
): void {
	snapshot = {
		status,
		analyticsGranted: categories.analyticsGranted,
		preferencesGranted: categories.preferencesGranted,
	};
	notifyAnalyticsConsentListeners();
}

export function hasAnalyticsCaptureConsent(): boolean {
	return snapshot.status === "decided" && snapshot.analyticsGranted;
}

export function hasPreferencesPersistenceConsent(): boolean {
	return snapshot.status === "decided" && snapshot.preferencesGranted;
}

export function isAnalyticsConsentUnknown(): boolean {
	return snapshot.status === "unknown";
}
